import { useEffect, useContext, useState } from "react";
import AppContext from "../../context";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { MdAccountCircle, MdOutlineDocumentScanner } from "react-icons/md";
import { FaRegCircleCheck } from "react-icons/fa6";
import { format } from "date-fns";
import { AddTappingMakananEntity, HasilTappingMakananEntity } from "../../entities/TappingMakananEntity";
import { FaRegWindowClose } from "react-icons/fa";
import css from "./TappingMakanan.module.css"
import PopupPilih from "../../components/Popup/PopupPilih";
import { PopUpPilihEntity } from "../../components/Popup/PopupPilihEntity";
import { LokasiService } from "../../services/lokasis";
import { TappingService } from "../../services/vendors_porsi";
import { VendorService } from "../../services/vendors";
import { VendorEntity } from "../../entities/VendorEntity";
import { FiRefreshCcw } from "react-icons/fi";
import RfidParser from "../../utils/rfid_parser";

export default function TappingMakanan() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const contextUserEntity = context.contextUserEntity;
  const stateShowLoading = context.stateShowLoading
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //
  const [showPopupPilih, setShowPopupPilih] = useState(false);
  const [popUpPilihEntity, setPopUpPilihEntity] = useState<PopUpPilihEntity>();
  const [sisaPorsi, setSisaPorsi] = useState<{ regular: number | null, vegetarian: number | null }>({ regular: null, vegetarian: null });
  const [inputTapping, setInputTapping] = useState<AddTappingMakananEntity | null>(null);
  const [hasilTapping, setHasilTapping] = useState<HasilTappingMakananEntity | null>(null);
  const [ncode, setNcode] = useState<string | null>(null)
  const [ncodeAfterInputed, setNcodeAfterInputed] = useState<string | null>(null)

  const isAdmin = contextUserEntity?.rolename == 'Admin'
  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handleSelectLokasi = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await LokasiService.GetAllLokasi();
      setPopUpPilihEntity(new PopUpPilihEntity({
        popupTitle: 'Pilih Lokasi',
        tableContent: resp,
        onClick: (row) => {
          setInputTapping((prevState: AddTappingMakananEntity | null) => {
            return new AddTappingMakananEntity({
              ...prevState,
              id_lokasi: row.id,
              lokasi: row.lokasi
            })
          })
        },
        onClose: () => { setShowPopupPilih(false) }
      }))
      setShowPopupPilih(true);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const handleSelectVendor = async () => {
    if (!isAdmin) return;
    contextShowLoadingFunc(true);
    try {
      const resp = await VendorService.GetAllVendor();
      setPopUpPilihEntity(new PopUpPilihEntity({
        popupTitle: 'Pilih Vendor',
        tableContent: resp,
        onClick: (row: VendorEntity) => {
          setInputTapping((prevState: AddTappingMakananEntity | null) => {
            return new AddTappingMakananEntity({
              ...prevState,
              id_vendor: row.id,
              vendor: row.nama
            })
          })
        },
        onClose: () => { setShowPopupPilih(false) }
      }))
      setShowPopupPilih(true);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  }

  const getPorsi = async () => {
    if (inputTapping == null || inputTapping.id_lokasi == null) return
    contextShowLoadingFunc(true);
    try {
      const resp = isAdmin
        ? await TappingService.GetAvailablePorsi(
          inputTapping?.id_lokasi,
          inputTapping?.id_vendor,
          format(inputTapping?.tanggal ?? new Date(), `yyyy-MM-dd`),
          inputTapping?.shift
        )
        : await TappingService.GetAvailablePorsi(inputTapping?.id_lokasi);
      setSisaPorsi({ regular: resp.sisa_regular, vegetarian: resp.sisa_vegetarian });
      setInputTapping((prevState: AddTappingMakananEntity | null) => {
        return new AddTappingMakananEntity({
          ...prevState,
          id_vendor_porsi: resp.id_vendor_porsi
        })
      })
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      setSisaPorsi({ regular: null, vegetarian: null });
      setInputTapping((prevState: AddTappingMakananEntity | null) => {
        return new AddTappingMakananEntity({
          ...prevState,
          id_vendor_porsi: undefined,
          id_lokasi: undefined,
          lokasi: undefined,
        })
      })
      setHasilTapping(new HasilTappingMakananEntity({ status: "UNAVAILABLE" }))
      contextShowLoadingFunc(false);
    }
  }

  const generateInput = async () => {
    let shift_now: number = 0
    let hours: number = new Date().getHours()
    if (hours >= 7 && hours < 15) {
      shift_now = 1
    } else if (hours >= 15 && hours < 23) {
      shift_now = 2
    } else {
      shift_now = 3
    }
    if (isAdmin) {
      setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
        return new AddTappingMakananEntity({
          ...prevState,
          tanggal: new Date(),
          shift: shift_now,
          tipe_makanan: "REGULAR"
        })
      });
    } else {
      setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
        return new AddTappingMakananEntity({
          ...prevState,
          vendor: contextUserEntity?.vendor,
          tanggal: new Date(),
          shift: shift_now,
          tipe_makanan: "REGULAR"
        })
      });
    }
  }

  const generateData = async () => {
    await getPorsi()
    await generateInput()
  };

  const handleTapCard = async (ncode: string) => {
    if (inputTapping == null || inputTapping.id_vendor_porsi == null || ncode == null || inputTapping.tipe_makanan == null) return
    if (ncode === ncodeAfterInputed) {
      setNcode(null)
      return
    }

    if (inputTapping?.tipe_makanan == "REGULAR") {
      if (sisaPorsi.regular == 0) {
        contextShowAlertFunc(new AlertEntity({ message: "Sisa Porsi 0 untuk Regular !", level: 3 }));
        setNcodeAfterInputed(ncode)
        setNcode(null)
        setHasilTapping((prevState: (HasilTappingMakananEntity | null)) => {
          return new HasilTappingMakananEntity({
            ...prevState,
            nama: undefined,
            id_card: undefined
          })
        });
        return
      }
    } else if (inputTapping?.tipe_makanan == "VEGETARIAN") {
      if (sisaPorsi.vegetarian == 0) {
        contextShowAlertFunc(new AlertEntity({ message: "Sisa Porsi 0 untuk Vegetarian !", level: 3 }));
        setNcodeAfterInputed(ncode)
        setNcode(null)
        setHasilTapping((prevState: (HasilTappingMakananEntity | null)) => {
          return new HasilTappingMakananEntity({
            ...prevState,
            nama: undefined,
            id_card: undefined
          })
        });
        return
      }
    }
    contextShowLoadingFunc(true);
    // let audio_success = new Audio("/success_sound.mp3")
    // let audio_failed = new Audio("/failed_sound.mp3")
    try {
      const resp = await TappingService.TappingKaryawan({ id_vendor_porsi: inputTapping.id_vendor_porsi, ncode: ncode, tipe: inputTapping.tipe_makanan });
      setNcodeAfterInputed(ncode)
      setNcode(null)
      setHasilTapping((prevState: (HasilTappingMakananEntity | null)) => {
        return new HasilTappingMakananEntity({
          ...prevState,
          status: "ACCEPT",
          nama: resp.data.nama,
          id_card: resp.data.id_card
        })
      });
      // audio_success.volume = 0.1
      // audio_success.play()
      getPorsi()
      contextShowLoadingFunc(false);
    } catch (error: any) {
      setNcodeAfterInputed(ncode)
      setNcode(null)
      // audio_failed.volume = 1
      // audio_failed.play()
      if (error.toLowerCase().includes("duplicate")) {
        setHasilTapping((prevState: (HasilTappingMakananEntity | null)) => {
          return new HasilTappingMakananEntity({
            ...prevState,
            status: "DOUBLE",
            nama: undefined,
            id_card: undefined
          })
        });
      } else {
        setHasilTapping((prevState: (HasilTappingMakananEntity | null)) => {
          return new HasilTappingMakananEntity({
            ...prevState,
            status: "REJECT",
            nama: undefined,
            id_card: undefined,
            message: error
          })
        });
      }
      contextShowLoadingFunc(false);
    }
  }

  const handleKeyDown = async (keydownEvent: KeyboardEvent) => {
    keydownEvent.preventDefault()
    const validChars: string[] = [
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
      'A', 'B', 'C', 'D', 'E', 'F',
      'a', 'b', 'c', 'd', 'e', 'f',
    ]
    if ((keydownEvent.key === 'v' && keydownEvent.ctrlKey) || keydownEvent.key.toLowerCase() === 'paste') {
      const clipboardItems = await window.navigator.clipboard.readText();
      setNcode(clipboardItems)
    } else if ((keydownEvent.ctrlKey && keydownEvent.key === 'M')) {
      if (ncode == null) { return }
      try {
        const parsed = RfidParser.HIDSeussHexParser(ncode)
        setNcode(parsed.internal_card.toString())
        handleTapCard(parsed.internal_card.toString())
      } catch (error: any) {
        setNcode(null)
        contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }))
      }
    }
    else if ((keydownEvent.key.toLowerCase() === 'enter')) {
      if (ncode == null) { return }
      handleTapCard(ncode)
    }
    else if (keydownEvent.ctrlKey) { }
    else if ((keydownEvent.ctrlKey && keydownEvent.key === 'J')) { }
    else if (keydownEvent.key.toLowerCase() === 'unidentified' || keydownEvent.key.toLowerCase() === 'shift') { }
    else if (validChars.includes(keydownEvent.key)) {
      if (keydownEvent.key) {
        setNcode((prev) => { return `${prev == null ? "" : prev}${keydownEvent.key}` })
      }
    } else if (keydownEvent.key == 'Backspace') {
      setNcode((prev) => {
        if (prev == null) return ""
        return `${prev.slice(0, -1)}`
      })
    }
    else { }
  };

  //get data waktu awal
  useEffect(() => {
    generateData();
  }, [contextAccessToken]);

  //get porsi setiap lokasi diubah
  useEffect(() => {
    if (inputTapping?.id_lokasi != undefined) {
      getPorsi();
    }
  }, [inputTapping?.id_lokasi]);

  //listener keyboard
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [ncode]);

  //selalu update tanggal dan shift setiap 30 detik
  useEffect(() => {
    if (isAdmin) return;
    const interval = setInterval(async () => {
      if (new Date().getSeconds() === 3 || new Date().getSeconds() === 33) {
        let shift_now: number = 0
        let hours: number = new Date().getHours()
        if (hours >= 7 && hours < 15) {
          shift_now = 1
        } else if (hours >= 15 && hours < 23) {
          shift_now = 2
        } else {
          shift_now = 3
        }
        setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
          return new AddTappingMakananEntity({
            ...prevState,
            shift: shift_now
          })
        });
        // TODO check jalan tidak
        if (shift_now != inputTapping?.shift) { await getPorsi() }
      }
    }, 1000);
    return () => {
      if (interval != null) {
        clearInterval(interval);
      }
    }
  }, []);


  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <div style={{ height: "95%", overflowY: "auto", display: "flex", flexDirection: "column" }}>

          <div style={{ flex: "10%", color: "var(--header-color)", display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "0vh 1vw", }}>
            <h1 style={{ flex: "50%", textAlign: "left" }} >Tapping Makanan</h1>
            <div style={{ flex: "50%", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", backgroundColor: "white", boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)", borderRadius: "20px" }} >
              <div className={(inputTapping?.tipe_makanan == "REGULAR" ? css.tipeMakananChoosed : css.tipeMakananNotChoosed)}
                onClick={() => {
                  setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
                    return new AddTappingMakananEntity({
                      ...prevState,
                      tipe_makanan: "REGULAR"
                    })
                  });
                }}
              >
                Regular
              </div>
              <div className={(inputTapping?.tipe_makanan == "VEGETARIAN" ? css.tipeMakananChoosed : css.tipeMakananNotChoosed)}
                onClick={() => {
                  setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
                    return new AddTappingMakananEntity({
                      ...prevState,
                      tipe_makanan: "VEGETARIAN"
                    })
                  });
                }}
              >
                Vegetarian
              </div>
            </div>
          </div>
          {/* Top Area */}
          <div style={{ flex: "45%", border: "0.7vh solid var(--header-color)", borderRadius: "2vh", backgroundColor: "white", margin: "2vh 1vw", display: "flex", flexDirection: "row", padding: "2vh 1vw" }}>
            <div style={{ flex: "20%", display: "flex", flexDirection: "column", fontWeight: "600" }}>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>Nama Vendor</div>
                <div style={{ color: "var(--tertiary-color)", marginRight: "5px" }}>:</div>
              </div>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>Tanggal</div>
                <div style={{ color: "var(--tertiary-color)", marginRight: "5px" }}>:</div>
              </div>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>Shift </div>
                <div style={{ color: "var(--tertiary-color)", marginRight: "5px" }}>:</div>
              </div>
              <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>Lokasi</div>
                <div style={{ color: "var(--tertiary-color)", marginRight: "5px" }}>:</div>
              </div>
            </div>
            {isAdmin
              ? <div style={{ flex: "40%", display: "flex", flexDirection: "column" }}>
                <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", paddingLeft: "10px", fontSize: "16px" }} onClick={() => { handleSelectVendor() }}>
                  <div>{inputTapping?.vendor ?? "Pilih Vendor Dahulu Disini "}</div>
                  <div>▼</div>
                </div>
                <label htmlFor="tanggal" style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", paddingLeft: "10px", fontSize: "16px" }}>
                  <input id="tanggal" type="date" style={{ border: "0px solid black", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", paddingLeft: 0, fontSize: "16px" }}
                    value={format(inputTapping?.tanggal ?? 0, "yyyy-MM-dd")}
                    onChange={(event) => {
                      setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
                        return new AddTappingMakananEntity({
                          ...prevState,
                          tanggal: new Date(event.target.value)
                        })
                      });
                    }}
                  />
                </label>
                <select style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", paddingLeft: "10px", fontSize: "16px" }}
                  value={inputTapping?.shift}
                  onChange={(event) => {
                    setInputTapping((prevState: (AddTappingMakananEntity | null)) => {
                      return new AddTappingMakananEntity({
                        ...prevState,
                        shift: parseInt(event.target.value)
                      })
                    });
                  }}>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                </select>
                <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", padding: "0px 10px", fontSize: "16px" }} onClick={() => { handleSelectLokasi() }}>
                  <div>{inputTapping?.lokasi ?? "Pilih Lokasi Dahulu Disini "}</div>
                  <div>▼</div>
                </div>
              </div>
              : <div style={{ flex: "40%", display: "flex", flexDirection: "column" }}>
                <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", paddingLeft: "10px", fontSize: "16px" }}>
                  {inputTapping?.vendor}
                </div>
                <label htmlFor="tanggal" style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", paddingLeft: "10px", fontSize: "16px" }}>
                  <input id="tanggal" type="date" style={{ border: "0px solid black", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", paddingLeft: 0, fontSize: "16px" }}
                    value={format(inputTapping?.tanggal ?? 0, "yyyy-MM-dd")} readOnly
                  />
                </label>
                <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", paddingLeft: "10px", fontSize: "16px" }}>
                  {inputTapping?.shift}
                </div>
                <div style={{ flex: "25%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#EEEEEE", color: "var(--header-color)", fontWeight: "600", margin: "1vh 1vw", borderRadius: "3px", padding: "0px 10px", fontSize: "16px" }} onClick={() => { handleSelectLokasi() }}>
                  <div>{inputTapping?.lokasi ?? "Pilih Lokasi Dahulu Disini "}</div>
                  <div>▼</div>
                </div>
              </div>}
            <div style={{ flex: "40%", display: "flex", flexDirection: "row", gap: "10px", cursor: "pointer" }} onClick={() => { getPorsi() }}>
              <div style={{ flex: "100%", backgroundColor: "var(--good-color)", borderRadius: "10px 10px 10px 10px", display: "flex", flexDirection: "column", position: "relative" }} >
                <div style={{ position: "absolute", top: "3%", right: "2%", color: "white" }}> <FiRefreshCcw /> </div>
                <div style={{ flex: "30%", display: "flex", alignItems: "end", justifyContent: "center", fontSize: "40px", fontWeight: "500", color: "white" }}>PORSI {inputTapping?.tipe_makanan}</div>
                <div style={{ flex: "70%", display: "flex", alignItems: "start", justifyContent: "center", fontSize: "120px", fontWeight: "500", color: "var(--secondary-color)" }}>{inputTapping?.tipe_makanan == "REGULAR" ? sisaPorsi.regular ?? 'N/A' : sisaPorsi.vegetarian ?? 'N/A'}</div>
              </div>
            </div>
          </div>

          {/* Bottom Area */}
          <div style={{ flex: "40%", borderRadius: "0vh 2vh 2vh 2vh", boxShadow: "3px 5px 5px rgba(0, 0, 0, 0.5)", backgroundColor: "white", margin: "0vh 1vw 2vh 1vw", display: "flex", flexDirection: "row", overflow: "hidden" }}>
            <div style={{ flex: "50%", display: "flex", height: "100%" }}>
              <div style={{ flex: "30%", color: "var(--hover-header)", fontSize: "160px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <MdAccountCircle />
              </div>
              <div style={{ flex: "70%", display: "flex", flexDirection: "column", gap: "5px" }}>
                <div style={{ flex: "45%", display: "flex", alignItems: "end", fontSize: "30px", color: "var(--hover-header)", fontWeight: "500", }}>
                  <div style={{ backgroundColor: (hasilTapping?.id_card == null ? "#EEEEEE" : undefined), width: "90%", borderRadius: "2px", textAlign: "left" }}>
                    {hasilTapping?.id_card ?? ""} &nbsp;
                  </div>
                </div>
                <div style={{ flex: "55%", display: "flex", alignItems: "start", fontSize: "45px", fontWeight: "600", color: "var(--header-color)" }}>
                  <div style={{ backgroundColor: (hasilTapping?.nama == null ? "#EEEEEE" : undefined), width: "90%", borderRadius: "2px", textAlign: "left" }}>
                    {hasilTapping?.nama ?? ""} &nbsp;
                  </div>
                </div>
              </div>
            </div>
            <div style={{ flex: "50%", backgroundColor: (hasilTapping?.status == "ACCEPT" ? "var(--good-color)" : hasilTapping?.status == "DOUBLE" ? "var(--secondary-color)" : hasilTapping?.status == "REJECT" ? "var(--bad-color)" : "#3C3C3C"), padding: "2vh 2vw", position: 'relative' }}>
              {
                hasilTapping?.status == "ACCEPT" ?
                  <>
                    <div style={{ fontSize: "80px", color: "var(--secondary-color)" }}><FaRegCircleCheck /></div>
                    <div style={{ fontSize: "30px", color: "white", fontWeight: "500" }}>Terima Kasih dan Selamat Menikmati.</div>
                  </>
                  : hasilTapping?.status == "REJECT" ?
                    <>
                      <div style={{ fontSize: "80px", color: "var(--secondary-color)" }}><FaRegWindowClose /></div>
                      <div style={{ fontSize: "23px", color: "white", fontWeight: "500" }}>Mohon Maaf Data Tidak Valid. Silakan Input Manual</div>
                      <div style={{ fontSize: "23px", color: "white", fontWeight: "500" }}>{`(${hasilTapping.message})`}</div>
                    </>
                    : hasilTapping?.status == "DOUBLE" ?
                      <>
                        <div style={{ fontSize: "80px", color: "var(--header-color)" }}><FaRegWindowClose /></div>
                        <div style={{ fontSize: "30px", color: "#3C3C3C", fontWeight: "500" }}>Anda Sudah Tapping Lebih dari 1X.</div>
                      </>
                      : hasilTapping?.status == "UNAVAILABLE" ?
                        <>
                          <div style={{ fontSize: "80px", color: "var(--secondary-color)" }}><FaRegWindowClose /></div>
                          <div style={{ fontSize: "30px", color: "white", fontWeight: "500" }}>Data Porsi Vendor Belum Siap.</div>
                        </>
                        :
                        <>
                          <div style={{ fontSize: "100px", color: "var(--secondary-color)", height: "120px" }}><MdOutlineDocumentScanner /></div>
                          <div style={{ fontSize: "30px", color: "white", fontWeight: "500" }}>Silakan Scan kartu Anda.</div>
                        </>
              }
              {(hasilTapping?.status == "ACCEPT" || hasilTapping?.status == "REJECT" || hasilTapping?.status == "DOUBLE") && ncode == null &&
                <div style={{ position: "absolute", left: "2%", bottom: "5%", fontWeight: "500", color: (hasilTapping?.status == "DOUBLE" ? "var(--header-color)" : "white"), borderRadius: "7px", padding: "2px", width: "100%", textAlign: "left", overflow: "auto" }}>
                  Input Code : {ncodeAfterInputed}
                </div>
              }
              <div style={{ position: "absolute", left: "2%", bottom: "5%", fontWeight: "500", color: (hasilTapping?.status == "DOUBLE" ? "var(--header-color)" : "white"), borderRadius: "7px", padding: "2px", width: "100%", textAlign: "left", overflow: "auto" }}>
                Input Code : {ncode}
              </div>
            </div>
          </div>
        </div>
        <div style={{ height: "5%", display: "flex", alignItems: "end", justifyContent: "center" }}>
          <div style={{ color: "var(--tertiary-color)", fontWeight: "600" }}>© Traxboards 2024 By Nagamas Putrajaya Engineering</div>
        </div>

        {popUpPilihEntity != null
          ? <PopupPilih
            showPopup={showPopupPilih}
            setShowPopup={setShowPopupPilih}
            popUpPilihEntity={popUpPilihEntity}
          />
          : <></>}

      </div >
    </>
  );
}
